import { Column, Entity, PrimaryGeneratedColumn } from 'typeorm';
import { BaseEntity } from './BaseEntity';
import { IRefRemoteControlOrigin } from './interface/IRefRemoteControlOrigin';

@Entity('ref_remote_control_origin')
export class RefRemoteControlOrigin extends BaseEntity implements IRefRemoteControlOrigin{
  apiMapping = {
      id: 'id',
      name: 'name',
  };

  @PrimaryGeneratedColumn()
  id: number;

  @Column()
  name: string;

  @Column({ nullable: true })
  isDeleted: boolean;
}
